module.exports = __webpack_public_path__ + "static/img/theme_04.96dc4198.png";